module.exports = __webpack_public_path__ + "img/z05.49b5120f.jpg";